import React from 'react'
import { Button } from '../../../../ui/Button'

interface ErrorStateProps {
  error: string
  onRetry: () => void
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="text-center py-12">
      <div className="text-red-600 mb-4">❌ {error}</div>
      <Button onClick={onRetry} variant="outline">
        Reintentar
      </Button>
    </div>
  )
}